document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Menüyü aç' : 'Menüyü kapat');
      mobileNav.hidden = open;
    });
  }
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var selector = root.querySelector('[data-variant-select]');
    var price = root.querySelector('[data-product-price]');
    if (selector && price) {
      selector.addEventListener('change', function () {
        var selected = selector.options[selector.selectedIndex];
        if (selected) price.textContent = selected.dataset.price || price.textContent;
      });
    }
  });
});
